import React, {useRef} from 'react';
import {Formik} from 'formik';

import Button from '../../../components/ui-controls/Button';
import TextInput from '../../../components/ui-controls/form/TextInput';
import {Paragraph} from '../../../components/ui-controls/text/Paragraph';
import {
  GiftCardEntryData,
  GiftCardEntrySchema,
} from '../../../models/schemas/giftCardsSchema';

const defaultValues: GiftCardEntryData = {
  number: '',
  pin: '',
};

type GiftCardDataInputViewProps = {
  isSubmitting: boolean;
  onSubmit: (number: string, pin: string) => void;
};

const GiftCardDataInputFormView = ({
  isSubmitting,
  onSubmit,
}: GiftCardDataInputViewProps) => {
  const pinInput = useRef<typeof TextInput>(null);

  const handleFormSubmit = async (values: GiftCardEntryData) =>
    onSubmit(values.number, values.pin);

  return (
    <>
      <Paragraph>
        Sometimes we lose track of our spending so we have made it easy to check the
        balance on your gift card and show you what you have spent.
        {'\n'}
        {'\n'}
        Simply type your Gift Card number and PIN below and submit.
      </Paragraph>
      <Formik<GiftCardEntryData>
        initialValues={defaultValues}
        onSubmit={handleFormSubmit}
        validationSchema={GiftCardEntrySchema}
        validateOnChange={false}
        validateOnBlur={false}
        >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values,
        }) => (
          <>
            <TextInput
              accessibilityLabel="Card number"
              autoFocus={true}
              errorMessage={errors.number}
              keyboardType="numeric"
              label="Card number"
              onBlur={handleBlur('number')}
              onChangeText={handleChange('number')}
              onSubmitEditing={() => pinInput.current?.focus()}
              placeholder="Enter the card number"
              returnKeyType="next"
              touched={touched.number}
              value={values.number}
            />
            <TextInput
              accessibilityLabel="PIN"
              errorMessage={errors.pin}
              keyboardType="numeric"
              label="PIN"
              onBlur={handleBlur('pin')}
              onChangeText={handleChange('pin')}
              onSubmitEditing={handleSubmit}
              placeholder="Enter the PIN"
              ref={pinInput}
              returnKeyType="done"
              touched={touched.pin}
              value={values.pin}
            />
            <Button
              disabled={isSubmitting}
              loading={isSubmitting}
              onPress={handleSubmit}
              title="SUBMIT"
            />
          </>
        )}
      </Formik>
    </>
  );
};

export default GiftCardDataInputFormView;
